import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Pipe({
    name: 'firstError',
    standalone: false
})
export class FirstErrorPipe implements PipeTransform {
    transform(control: UntypedFormGroup): any {
        const key = Object.keys(control.errors || {})[0];
        return 'validation-errors/' + (key || '');
    }
}